import QRCode from './src/QRCode'

export default QRCode
